import { Badge, Button, List, Modal, Pagination, Segmented, Space, Tag, Typography, message } from 'antd'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { getInboxAnnouncement, listInboxAnnouncements, markAnnouncementRead, notifyAnnouncementChanged, type AnnouncementItem } from '../../services/announcements'

const priorityLabels = { NORMAL: '普通', IMPORTANT: '重要', URGENT: '緊急' }
const priorityColors = { NORMAL: 'default', IMPORTANT: 'gold', URGENT: 'red' }

export default function AnnouncementCenter() {
  const [params, setParams] = useSearchParams()
  const [items, setItems] = useState<AnnouncementItem[]>([])
  const [page, setPage] = useState(1)
  const [total, setTotal] = useState(0)
  const [unreadOnly, setUnreadOnly] = useState(false)
  const [detail, setDetail] = useState<AnnouncementItem | null>(null)

  const load = async () => {
    try {
      const response = await listInboxAnnouncements({ page, size: 20, unreadOnly })
      setItems(response.data.items)
      setTotal(response.data.pagination.total)
    } catch (error: unknown) {
      message.error(error instanceof Error ? error.message : '載入公告失敗')
    }
  }

  const openDetail = async (id: string) => {
    try {
      const response = await getInboxAnnouncement(id)
      setDetail(response.data)
      await markAnnouncementRead(id)
      notifyAnnouncementChanged()
      await load()
    } catch (error: unknown) {
      message.error(error instanceof Error ? error.message : '載入公告失敗')
    }
  }

  useEffect(() => { load() }, [page, unreadOnly])
  useEffect(() => {
    const id = params.get('id')
    if (id) openDetail(id)
  }, [params])

  return (
    <div>
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <Space style={{ width: '100%', justifyContent: 'space-between' }}>
          <Typography.Title level={4} style={{ margin: 0 }}>公告中心</Typography.Title>
          <Segmented value={unreadOnly ? 'unread' : 'all'} options={[{ label: '全部', value: 'all' }, { label: '未讀', value: 'unread' }]} onChange={(value) => { setUnreadOnly(value === 'unread'); setPage(1) }} />
        </Space>
        <List
          bordered
          dataSource={items}
          locale={{ emptyText: '目前沒有公告' }}
          renderItem={(item) => (
            <List.Item>
              <Button type="text" block className="announcement-list-button" onClick={() => openDetail(item.id)}>
                <span className="announcement-list-title">{!item.readAt && <Badge status="processing" />}<span>{item.title}</span><Tag color={priorityColors[item.priority]}>{priorityLabels[item.priority]}</Tag></span>
                <span className="announcement-list-time">{new Date(item.visibleAt).toLocaleString()}</span>
              </Button>
            </List.Item>
          )}
        />
        <Pagination current={page} pageSize={20} total={total} hideOnSinglePage onChange={setPage} />
      </Space>
      <Modal open={Boolean(detail)} footer={null} onCancel={() => { setDetail(null); setParams({}) }} title={detail?.title}>
        <Typography.Paragraph className="announcement-body">{detail?.content}</Typography.Paragraph>
      </Modal>
    </div>
  )
}
